import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { CardBodyComponent, CardComponent } from '@groundworks/ngx-groundworks-ui';
import { FinancingInfo } from '../../sdk/sdk';

@Component({
  selector: 'app-financing-summary',
  imports: [CardComponent, CardBodyComponent, CommonModule],
  templateUrl: './financing-summary.component.html',
})
export class FinancingSummaryComponent {
  @Input() soldTotal: number | undefined = undefined;
  @Input() financing: FinancingInfo = new FinancingInfo();
}
